module.exports = __webpack_public_path__ + "img/ic_mpe_bed_sm3_normal.6de2e8d2.png";